<template>
    <div class="index-box">
      <el-row :gutter="24">
        <el-col :span="8"><div class="grid-content bg-purple">

          <div class="content-box" >
            <router-link to="/tabs/index">
              <div class="img-box"><em class="iconfont icon-dwzattachment"></em></div>
            <div class="text-box">
              <h2>短网址</h2>
              <span>缩短链接，生成短网址</span>
            </div>
            </router-link>
          </div>

        </div></el-col>
        <el-col :span="8"><div class="grid-content bg-purple">

          <div class="content-box" >
            <router-link to="/exlcusiveDomain">
              <div class="img-box"><em class="iconfont icon-dwzRectangleCopy4"></em></div>
              <div class="text-box">
                <h2>专属短链</h2>
                <span>域名直接跳转，更短的短链接</span>
              </div>
            </router-link>
          </div>

        </div>
        </el-col>
        <el-col :span="8"><div class="grid-content bg-purple">

          <div class="content-box" >
            <router-link to="/home_shibie">
              <div class="img-box"><em class="iconfont icon-dwzRectangleCopy4"></em></div>
              <div class="text-box">
                <h2>识别二维码</h2>
                <span>通过图片识别图片内容、链接</span>
              </div>
            </router-link>
          </div>

        </div>
        </el-col>
        <el-col :span="8"><div class="grid-content bg-purple">
          <div class="content-box" >
            <router-link to="/apidoc">
              <div class="img-box"><em class="iconfont icon-dwzAPI"></em></div>
              <div class="text-box">
                <h2>API生成</h2>
                <span>功能：使用API接口生成短链接</span>
              </div>
            </router-link>
          </div>
        </div></el-col>
        <el-col :span="8"><div class="grid-content bg-purple">
          <div class="content-box" >
            <router-link to="/tabs/liveCode">
              <div class="img-box"><em class="iconfont icon-dwzerweima"></em></div>
              <div class="text-box">
                <h2>加粉二维码</h2>
                <span>本功能可将您的多个二维码轮流展现</span>
              </div>
            </router-link>
          </div>
        </div></el-col>

        <el-col :span="8"><div class="grid-content bg-purple">
          <div class="content-box" >
            <router-link to="/tabs/shopGoods">
              <div class="img-box"><em class="iconfont icon-dwztaobao"></em></div>
              <div class="text-box">
                <h2>淘宝短连接</h2>
                <span>电商缩短链接，生成短网址</span>
              </div>
            </router-link>
          </div>
        </div></el-col>
        <el-col :span="8"><div class="grid-content bg-purple">
          <div class="content-box" >
            <router-link to="/tabs/webPage">
              <div class="img-box"><em class="el-icon-document-checked"></em></div>
              <div class="text-box">
                <h2>h5页面创作</h2>
                <span>功能：生成一个h5网页</span>
              </div>
            </router-link>
          </div>
        </div></el-col>
        <el-col :span="8"><div class="grid-content bg-purple">
          <div class="content-box" >
            <router-link to="/home_wx">
              <div class="img-box"><em class="iconfont icon-dwzlanjie"></em></div>
              <div class="text-box">
                <h2>微信拦截</h2>
                <span>查询微信拦截情况，并第一时间通知</span>
              </div>
            </router-link>
          </div>
        </div></el-col>
      </el-row>
    </div>

</template>

<script>
    import QRCode from 'qrcodejs2';
    export default {
        name: "Index",
        data() {
            return {
                shortId: 0,
                shortUrl: "123456789",
                isShowResult: false,
            }
        },
        mounted() {
        },
        methods: {

        },
    }
</script>

<style scoped>
    .index-box{
        width: 90%;
        height: auto;
        margin-left: 40px;
        padding-top: 20px;

        /*padding: 30px 120px 30px 40px;*/
        /*border: #0A246A 1px solid;*/
    }

    .result-box .top-ico i{
        display: inline-block;
        font-size: 40px;
        margin-right: 10px;
        vertical-align: top;
    }
    .el-row {
      margin-bottom: 20px;
    }
    :last-child {
       margin-bottom: 0;
     }

    .el-col {
      border-radius: 4px;
    }
    .bg-purple-dark {
      background: #99a9bf;
    }
    .bg-purple {
      /*background: #d3dce6;*/
    }
    .bg-purple-light {
      background: #e5e9f2;
    }
    .grid-content {
      /*border-radius: 4px;*/
      min-height: 36px;
      margin-bottom: 20px;
      border: #b1b1b1 1px dashed ;
      /*height: 120px;*/
      padding: 20px;
    }
    .row-bg {
      padding: 10px 0;
      background-color: #f9fafc;
    }
    .content-box{
      height: 50px;
    }
    .content-box .img-box{
      width: 40px;
      height: 42px;
      float: left;
    }
    .content-box .img-box em{
      font-size: 35px;
      width: 50px;
      display: block;
      height: 50px;
      color:#099cf4;
    }
    .content-box .text-box{
      padding-left: 10px;
      float: left;
    }
    .content-box .text-box h2{
      color: #202837;
      font-weight: 500;
    }
    .content-box .text-box span{
      font-size: 12px;
      color: #a9a9a9;
      font-weight: bolder;
      width:200px;position: relative;overflow: hidden;display: block
    }
</style>
